import React from "react";
import "./index.css";

type Size = "small" | "medium" | "big";
type Position = "moreLeft" | "fullLeft" | "left" | "right";

interface Props {
    id?: string,
    icon: string,
    color?: string,
    onClick?: Function,
    disabled?: boolean,
    tooltip?: any,
    tooltipPosition?: Position,
    badge?: {
        number: number,
        status: string
    },
    size?: Size,
}

const LcIcon: React.FC<Props> = (props) => {

    const disabled = props.disabled || false;

    return (
        <div
            id={props.id}
            className={`lcicon${disabled ? " disabled" : ""} ${props.size || ""}`}
            onClick={() => !disabled && props.onClick && props.onClick()}
        >
            <i className={props.icon} style={{ color: props.color, marginRight: "0px" }} />
            {
                props.badge && props.badge.number > 0 &&
                <div className={`badge bg-${props.badge.status}`}>
                    <span> {props.badge.number > 99 ? "+99" : props.badge.number} </span>
                </div>
            }
            {
                props.tooltip &&
                <div className="tooltip">
                    <div className="body">
                        <div className={`content ${props.tooltipPosition || ""}`}>
                            {props.tooltip}
                        </div>
                        <span className="arrow" />
                    </div>
                </div>
            }
        </div>
    );
}

//export const LcIcon = React.memo(LcIconBase);
export default LcIcon